<template>
  <div class="homepage-banners">
    <Swiper
      ref="bannerSwiper"
      :options="swiperOptions"
      class="swiper-container swiper-banner"
    >
      <SwiperSlide
        v-for="(item, i) in banners"
        :key="i"
        class="swiper-slide urlBtn"
      >
        <a @click.prevent="gioTrack((i+1), item.url)">
          <img class="ban-img" :src="item.image" />
        </a>
        <div class="ban-timing" v-if="isShowCountDown(item)">
          <div class="sw-bg">
            <img
              class="ban-clock"
              src="https://resource.rcclchina.com.cn/homePage/mobile/clock.png"
              alt=""
            />
            <span class="act">倒计时</span>
          </div>
          <HomeCountDown :countDownNum="getCountDown(item)" />
        </div>
      </SwiperSlide>
      <!-- <div class="swiper-pagination" v-if="banners.length > 1"></div> -->
    </Swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { gioAdsTracking } from "@/utilities/tools";
const HomeCountDown = () => import("@/components/Home/HomeCountDown");
export default {
  name: "HomeBannerKV",
  components: {
    HomeCountDown,
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  props: {
    banners: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      swiperOptions: {
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: ".swiper-pagination",
        },
        loop: true,
      },
    };
  },
  methods: {
    isShowCountDown(item) {
      let now = new Date();
      const endTime = item.promoEndTime;
      let checkEndTime = 0;
      if (endTime && endTime.length > 0) {
        checkEndTime = new Date(endTime.replace("T", " ")).getTime();
        let result = item.showCountDown && checkEndTime > now.getTime();
        return result;
      }
      return false;
    },
    getCountDown(item) {
      const endTime = item.promoEndTime;
      let checkEndTime = 0;
      if (endTime && endTime.length > 0) {
        checkEndTime = new Date(endTime.replace("T", " ")).getTime();
      }
      return checkEndTime;
    },
		gioTrack(index, url) {
			const eventObject = {
				"adsType": "bn",
				"bnOrder": index,
				"desUrl": url
			}
			gioAdsTracking(eventObject);
			location.href = url;
		}
  },
  computed: {
    timing() {
      return "timing";
    },
    swiper() {
      return this.$refs.bannerSwiper.$swiper;
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  
  text-transform: uppercase;
}
img {
  display: block;
}

/*头图*/
.homepage-banners .ban-img {
  width: 375px;
  height: 292px;
}
.homepage-banners .ban-clock {
  width: 15px;
  height: 15px;
  display: inline-block;
  position: relative;
  top: 6px;
  margin-bottom: 4px;
}
.homepage-banners .swiper-container {
  padding-bottom: 0;
}
.homepage-banners
  .swiper-container
  .swiper-pagination-bullets
  .swiper-pagination-bullet {
  width: 9px;
  height: 9px;
  background: #fff;
  z-index: -1;
}
.homepage-banners
  .swiper-container
  .swiper-pagination-bullets
  .swiper-pagination-bullet-active {
  background: #fbc500;
}
.homepage-banners .ban-timing {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateX(-50%);
  height: 190px;
  width: 28px;
  text-align: center;
  color: #fff;
  background: #ee0027;
  font-size: 12px;
  font-weight: 400;
  /*letter-spacing: 1px;*/
  transform: translateY(-50%);
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;
  overflow: hidden;
}
.homepage-banners .ban-timing .sw-bg {
  width: 100%;
  height: 80px;
  background: #b3001e;
}
.homepage-banners .ban-timing .act {
  font-size: 15px;
  position: relative;
  top: -2px;
  display: block;
  line-height: 1.2;
}
.homepage-banners .ban-timing .num {
  font-size: 18px;
  font-weight: bold;
}
.homepage-banners .ban-timing .sw-time {
  font-size: 12px;
  line-height: 1;
  margin-top: 5px;
}
.homepage-banners .ban-timing .sw-time > div {
  margin-bottom: 4px;
}
</style>

